// extracted by mini-css-extract-plugin
export default {"page-footer-holder":"PageFooter_page-footer-holder__IhDeq","page-footer":"PageFooter_page-footer__l0SV7"};